import React, { Dispatch, FC, SetStateAction } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 2.625em;
  max-width: 35em;
  width: 100%;
  transform: translateX(-2.5em);
`;

const Separator = styled.div`
  width: 1px;
  height: 100%;
  background-color: #000;
`;

const Button = styled.button`
  width: 16em;
  height: 2em;
  position: relative;
`;

const Label = styled.span<{ isActive: boolean }>`
  position: relative;
  text-transform: capitalize;
  font-size: 1.5em;
  font-weight: ${p => (p.isActive ? 600 : 400)};
  transition: all 0.2s ease;
`;

const UnderLine = styled.div<{ isActive: boolean }>`
  position: absolute;
  bottom: -4px;
  left: 0;
  right: 0;
  height: 1px;
  background-color: ${p => p.theme.colors.red};
  pointer-events: none;
  opacity: ${p => (p.isActive ? 1 : 0)};
  transform: ${p => (p.isActive ? `scaleX(1)` : `scaleX(0.5)`)};
  transition: all 0.2s ease;
`;

const copy = {
  question: `Pitanja`,
  partner: `Saradnja`,
};

type Props = {
  setPick: Dispatch<SetStateAction<'question' | 'partner'>>;
  isQuestion: boolean;
};

export const FormPicker: FC<Props> = ({ setPick, isQuestion }) => {
  return (
    <Wrapper>
      <Button onClick={() => setPick('question')}>
        <Label isActive={isQuestion}>
          {copy.question}
          <UnderLine isActive={isQuestion} />
        </Label>
      </Button>
      <Separator />
      <Button onClick={() => setPick('partner')}>
        <Label isActive={!isQuestion}>
          {copy.partner}
          <UnderLine isActive={!isQuestion} />
        </Label>
      </Button>
    </Wrapper>
  );
};
